// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file notifications/v1/notifications_service.proto (package notifications.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import type { CommentNotificationType, NotificationType } from "./model_pb";
import { file_notifications_v1_model } from "./model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file notifications/v1/notifications_service.proto.
 */
export const file_notifications_v1_notifications_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_notifications_v1_model]);

/**
 * @generated from message notifications.v1.GetUserAssignmentsRequest
 */
export type GetUserAssignmentsRequest = Message<"notifications.v1.GetUserAssignmentsRequest"> & {
};

/**
 * Describes the message notifications.v1.GetUserAssignmentsRequest.
 * Use `create(GetUserAssignmentsRequestSchema)` to create a new message.
 */
export const GetUserAssignmentsRequestSchema: GenMessage<GetUserAssignmentsRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 0);

/**
 * @generated from message notifications.v1.GetUserAssignmentsResponse
 */
export type GetUserAssignmentsResponse = Message<"notifications.v1.GetUserAssignmentsResponse"> & {
  /**
   * @generated from field: repeated string third_parties = 1;
   */
  thirdParties: string[];

  /**
   * @generated from field: repeated string projects = 2;
   */
  projects: string[];

  /**
   * @generated from field: repeated string assessments = 3;
   */
  assessments: string[];
};

/**
 * Describes the message notifications.v1.GetUserAssignmentsResponse.
 * Use `create(GetUserAssignmentsResponseSchema)` to create a new message.
 */
export const GetUserAssignmentsResponseSchema: GenMessage<GetUserAssignmentsResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 1);

/**
 * @generated from message notifications.v1.ListSlackChannelsRequest
 */
export type ListSlackChannelsRequest = Message<"notifications.v1.ListSlackChannelsRequest"> & {
};

/**
 * Describes the message notifications.v1.ListSlackChannelsRequest.
 * Use `create(ListSlackChannelsRequestSchema)` to create a new message.
 */
export const ListSlackChannelsRequestSchema: GenMessage<ListSlackChannelsRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 2);

/**
 * @generated from message notifications.v1.ListSlackChannelsResponse
 */
export type ListSlackChannelsResponse = Message<"notifications.v1.ListSlackChannelsResponse"> & {
  /**
   * @generated from field: repeated notifications.v1.SlackChannel channels = 1;
   */
  channels: SlackChannel[];
};

/**
 * Describes the message notifications.v1.ListSlackChannelsResponse.
 * Use `create(ListSlackChannelsResponseSchema)` to create a new message.
 */
export const ListSlackChannelsResponseSchema: GenMessage<ListSlackChannelsResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 3);

/**
 * @generated from message notifications.v1.SlackChannel
 */
export type SlackChannel = Message<"notifications.v1.SlackChannel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_private = 3;
   */
  isPrivate: boolean;
};

/**
 * Describes the message notifications.v1.SlackChannel.
 * Use `create(SlackChannelSchema)` to create a new message.
 */
export const SlackChannelSchema: GenMessage<SlackChannel> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 4);

/**
 * @generated from message notifications.v1.GetSlackUserDmLinkRequest
 */
export type GetSlackUserDmLinkRequest = Message<"notifications.v1.GetSlackUserDmLinkRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message notifications.v1.GetSlackUserDmLinkRequest.
 * Use `create(GetSlackUserDmLinkRequestSchema)` to create a new message.
 */
export const GetSlackUserDmLinkRequestSchema: GenMessage<GetSlackUserDmLinkRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 5);

/**
 * @generated from message notifications.v1.GetSlackUserDmLinkResponse
 */
export type GetSlackUserDmLinkResponse = Message<"notifications.v1.GetSlackUserDmLinkResponse"> & {
  /**
   * Set only when status is STATUS_OK.
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: notifications.v1.GetSlackUserDmLinkResponse.Status status = 2;
   */
  status: GetSlackUserDmLinkResponse_Status;
};

/**
 * Describes the message notifications.v1.GetSlackUserDmLinkResponse.
 * Use `create(GetSlackUserDmLinkResponseSchema)` to create a new message.
 */
export const GetSlackUserDmLinkResponseSchema: GenMessage<GetSlackUserDmLinkResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 6);

/**
 * @generated from enum notifications.v1.GetSlackUserDmLinkResponse.Status
 */
export enum GetSlackUserDmLinkResponse_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_OK = 1;
   */
  OK = 1,

  /**
   * org Slack not connected, or its token is inactive/revoked
   *
   * @generated from enum value: STATUS_NOT_CONNECTED = 2;
   */
  NOT_CONNECTED = 2,

  /**
   * Slack app lacks the users:read.email scope
   *
   * @generated from enum value: STATUS_MISSING_SCOPE = 3;
   */
  MISSING_SCOPE = 3,

  /**
   * email is not a member of the workspace
   *
   * @generated from enum value: STATUS_USER_NOT_FOUND = 4;
   */
  USER_NOT_FOUND = 4,
}

/**
 * Describes the enum notifications.v1.GetSlackUserDmLinkResponse.Status.
 */
export const GetSlackUserDmLinkResponse_StatusSchema: GenEnum<GetSlackUserDmLinkResponse_Status> = /*@__PURE__*/
  enumDesc(file_notifications_v1_notifications_service, 6, 0);

/**
 * @generated from message notifications.v1.SendNotificationRequest
 */
export type SendNotificationRequest = Message<"notifications.v1.SendNotificationRequest"> & {
  /**
   * @generated from field: notifications.v1.NotificationType type = 1;
   */
  type: NotificationType;

  /**
   * @generated from field: repeated string recipient_emails = 2;
   */
  recipientEmails: string[];

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId: string;

  /**
   * @generated from field: string org_company_id = 4;
   */
  orgCompanyId: string;

  /**
   * @generated from field: bytes properties = 5;
   */
  properties: Uint8Array;

  /**
   * @generated from field: optional string org_assessment_id = 6;
   */
  orgAssessmentId?: string;
};

/**
 * Describes the message notifications.v1.SendNotificationRequest.
 * Use `create(SendNotificationRequestSchema)` to create a new message.
 */
export const SendNotificationRequestSchema: GenMessage<SendNotificationRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 7);

/**
 * @generated from message notifications.v1.SendNotificationResponse
 */
export type SendNotificationResponse = Message<"notifications.v1.SendNotificationResponse"> & {
};

/**
 * Describes the message notifications.v1.SendNotificationResponse.
 * Use `create(SendNotificationResponseSchema)` to create a new message.
 */
export const SendNotificationResponseSchema: GenMessage<SendNotificationResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 8);

/**
 * @generated from message notifications.v1.SendCommentNotificationRequest
 */
export type SendCommentNotificationRequest = Message<"notifications.v1.SendCommentNotificationRequest"> & {
  /**
   * @generated from field: notifications.v1.CommentNotificationType type = 1;
   */
  type: CommentNotificationType;

  /**
   * @generated from field: string assessment_id = 2;
   */
  assessmentId: string;

  /**
   * @generated from field: string thread_id = 3;
   */
  threadId: string;

  /**
   * @generated from field: string comment_id = 4;
   */
  commentId: string;

  /**
   * @generated from field: string comment_body = 5;
   */
  commentBody: string;

  /**
   * @generated from field: repeated string recipient_user_ids = 6;
   */
  recipientUserIds: string[];

  /**
   * OrgControlStatus id.
   *
   * @generated from field: string control_id = 7;
   */
  controlId: string;
};

/**
 * Describes the message notifications.v1.SendCommentNotificationRequest.
 * Use `create(SendCommentNotificationRequestSchema)` to create a new message.
 */
export const SendCommentNotificationRequestSchema: GenMessage<SendCommentNotificationRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 9);

/**
 * @generated from message notifications.v1.SendCommentNotificationResponse
 */
export type SendCommentNotificationResponse = Message<"notifications.v1.SendCommentNotificationResponse"> & {
};

/**
 * Describes the message notifications.v1.SendCommentNotificationResponse.
 * Use `create(SendCommentNotificationResponseSchema)` to create a new message.
 */
export const SendCommentNotificationResponseSchema: GenMessage<SendCommentNotificationResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 10);

/**
 * @generated from message notifications.v1.IsUserSubscribedToTenantRequest
 */
export type IsUserSubscribedToTenantRequest = Message<"notifications.v1.IsUserSubscribedToTenantRequest"> & {
};

/**
 * Describes the message notifications.v1.IsUserSubscribedToTenantRequest.
 * Use `create(IsUserSubscribedToTenantRequestSchema)` to create a new message.
 */
export const IsUserSubscribedToTenantRequestSchema: GenMessage<IsUserSubscribedToTenantRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 11);

/**
 * @generated from message notifications.v1.IsUserSubscribedToTenantResponse
 */
export type IsUserSubscribedToTenantResponse = Message<"notifications.v1.IsUserSubscribedToTenantResponse"> & {
  /**
   * @generated from field: bool is_subscribed = 1;
   */
  isSubscribed: boolean;
};

/**
 * Describes the message notifications.v1.IsUserSubscribedToTenantResponse.
 * Use `create(IsUserSubscribedToTenantResponseSchema)` to create a new message.
 */
export const IsUserSubscribedToTenantResponseSchema: GenMessage<IsUserSubscribedToTenantResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 12);

/**
 * @generated from message notifications.v1.UpdateUserTenantSubscriptionRequest
 */
export type UpdateUserTenantSubscriptionRequest = Message<"notifications.v1.UpdateUserTenantSubscriptionRequest"> & {
  /**
   * @generated from field: bool subscribed = 1;
   */
  subscribed: boolean;
};

/**
 * Describes the message notifications.v1.UpdateUserTenantSubscriptionRequest.
 * Use `create(UpdateUserTenantSubscriptionRequestSchema)` to create a new message.
 */
export const UpdateUserTenantSubscriptionRequestSchema: GenMessage<UpdateUserTenantSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 13);

/**
 * @generated from message notifications.v1.UpdateUserTenantSubscriptionResponse
 */
export type UpdateUserTenantSubscriptionResponse = Message<"notifications.v1.UpdateUserTenantSubscriptionResponse"> & {
};

/**
 * Describes the message notifications.v1.UpdateUserTenantSubscriptionResponse.
 * Use `create(UpdateUserTenantSubscriptionResponseSchema)` to create a new message.
 */
export const UpdateUserTenantSubscriptionResponseSchema: GenMessage<UpdateUserTenantSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 14);

/**
 * @generated from message notifications.v1.GetPortalReminderSettingRequest
 */
export type GetPortalReminderSettingRequest = Message<"notifications.v1.GetPortalReminderSettingRequest"> & {
};

/**
 * Describes the message notifications.v1.GetPortalReminderSettingRequest.
 * Use `create(GetPortalReminderSettingRequestSchema)` to create a new message.
 */
export const GetPortalReminderSettingRequestSchema: GenMessage<GetPortalReminderSettingRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 15);

/**
 * @generated from message notifications.v1.GetPortalReminderSettingResponse
 */
export type GetPortalReminderSettingResponse = Message<"notifications.v1.GetPortalReminderSettingResponse"> & {
  /**
   * @generated from field: bool due_date_reminder_enabled = 1;
   */
  dueDateReminderEnabled: boolean;

  /**
   * nil = OFF, otherwise the recurring
   *
   * @generated from field: optional google.protobuf.Duration cadence_interval = 2;
   */
  cadenceInterval?: Duration;

  /**
   * @generated from field: bool cc_business_owner_enabled = 3;
   */
  ccBusinessOwnerEnabled: boolean;
};

/**
 * Describes the message notifications.v1.GetPortalReminderSettingResponse.
 * Use `create(GetPortalReminderSettingResponseSchema)` to create a new message.
 */
export const GetPortalReminderSettingResponseSchema: GenMessage<GetPortalReminderSettingResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 16);

/**
 * @generated from message notifications.v1.SetPortalReminderSettingRequest
 */
export type SetPortalReminderSettingRequest = Message<"notifications.v1.SetPortalReminderSettingRequest"> & {
  /**
   * @generated from field: bool due_date_reminder_enabled = 1;
   */
  dueDateReminderEnabled: boolean;

  /**
   * nil = OFF, otherwise the recurring
   *
   * @generated from field: optional google.protobuf.Duration cadence_interval = 2;
   */
  cadenceInterval?: Duration;

  /**
   * @generated from field: bool cc_business_owner_enabled = 3;
   */
  ccBusinessOwnerEnabled: boolean;
};

/**
 * Describes the message notifications.v1.SetPortalReminderSettingRequest.
 * Use `create(SetPortalReminderSettingRequestSchema)` to create a new message.
 */
export const SetPortalReminderSettingRequestSchema: GenMessage<SetPortalReminderSettingRequest> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 17);

/**
 * @generated from message notifications.v1.SetPortalReminderSettingResponse
 */
export type SetPortalReminderSettingResponse = Message<"notifications.v1.SetPortalReminderSettingResponse"> & {
};

/**
 * Describes the message notifications.v1.SetPortalReminderSettingResponse.
 * Use `create(SetPortalReminderSettingResponseSchema)` to create a new message.
 */
export const SetPortalReminderSettingResponseSchema: GenMessage<SetPortalReminderSettingResponse> = /*@__PURE__*/
  messageDesc(file_notifications_v1_notifications_service, 18);

/**
 * @generated from service notifications.v1.NotificationsService
 */
export const NotificationsService: GenService<{
  /**
   * @generated from rpc notifications.v1.NotificationsService.ListSlackChannels
   */
  listSlackChannels: {
    methodKind: "unary";
    input: typeof ListSlackChannelsRequestSchema;
    output: typeof ListSlackChannelsResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.GetSlackUserDmLink
   */
  getSlackUserDmLink: {
    methodKind: "unary";
    input: typeof GetSlackUserDmLinkRequestSchema;
    output: typeof GetSlackUserDmLinkResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.SendNotification
   */
  sendNotification: {
    methodKind: "unary";
    input: typeof SendNotificationRequestSchema;
    output: typeof SendNotificationResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.SendCommentNotification
   */
  sendCommentNotification: {
    methodKind: "unary";
    input: typeof SendCommentNotificationRequestSchema;
    output: typeof SendCommentNotificationResponseSchema;
  },
  /**
   * New subscription management APIs
   *
   * @generated from rpc notifications.v1.NotificationsService.IsUserSubscribedToTenant
   */
  isUserSubscribedToTenant: {
    methodKind: "unary";
    input: typeof IsUserSubscribedToTenantRequestSchema;
    output: typeof IsUserSubscribedToTenantResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.GetUserAssignments
   */
  getUserAssignments: {
    methodKind: "unary";
    input: typeof GetUserAssignmentsRequestSchema;
    output: typeof GetUserAssignmentsResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.UpdateUserTenantSubscription
   */
  updateUserTenantSubscription: {
    methodKind: "unary";
    input: typeof UpdateUserTenantSubscriptionRequestSchema;
    output: typeof UpdateUserTenantSubscriptionResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.GetPortalReminderSetting
   */
  getPortalReminderSetting: {
    methodKind: "unary";
    input: typeof GetPortalReminderSettingRequestSchema;
    output: typeof GetPortalReminderSettingResponseSchema;
  },
  /**
   * @generated from rpc notifications.v1.NotificationsService.SetPortalReminderSetting
   */
  setPortalReminderSetting: {
    methodKind: "unary";
    input: typeof SetPortalReminderSettingRequestSchema;
    output: typeof SetPortalReminderSettingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_notifications_v1_notifications_service, 0);

